// @ts-check
import required from 'utils/required';

export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DISMISS_FLASH_MESSAGE = 'DISMISS_FLASH_MESSAGE';

const DEFAULT_DELAY = 4000;
const DEFAULT_FLASH_TITLES = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
};

/** @typedef {{
  id: number,
  title: string,
  message: string,
  flashType: 'success' | 'error' | 'warning' | 'info',
  sticky?: boolean,
  delay?: number
}} AddFlashParams */

/**
 * @param {AddFlashParams} flashParams
 */
const addFlashMessage = flashParams => {
  const {
    id = required('id'),
    title = required('title'),
    message = required('message'),
    flashType = required('flashType'),
    sticky = false,
    delay = DEFAULT_DELAY,
  } = flashParams;
  return {
    type: ADD_FLASH_MESSAGE,
    id,
    title,
    message,
    flashType,
    sticky,
    delay,
  };
};

/**
 * @param {'info' | 'success' | 'error' | 'warning'} flashType
 * @returns {function({message: string, title?: string, delay?: number, sticky?: boolean}): any}
 */
function flashFactory(flashType) {
  return ({
    message,
    title = DEFAULT_FLASH_TITLES[flashType],
    delay = undefined,
    sticky = undefined,
  }) => {
    const id = Date.now();
    return addFlashMessage({
      flashType,
      title,
      message,
      id,
      sticky,
      delay,
    });
  };
}

const flashInfo = flashFactory('info');
const flashSuccess = flashFactory('success');
const flashError = flashFactory('error');
const flashWarning = flashFactory('warning');

const dismissFlashMessage = ({ id = required('id') }) => ({ type: DISMISS_FLASH_MESSAGE, id });

export { flashInfo, flashSuccess, flashError, flashWarning, addFlashMessage, dismissFlashMessage };
